import '../App.css';
import React from 'react';
import Header from '../Component/Header';
import { connect } from 'react-redux'
import { language } from '../language';
import Moment from 'moment-timezone';
import { Button, Form, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Table from 'react-bootstrap/Table'
import SearchUsersModal from '../Component/Modal/SearchUsersModal';
import Alert from 'react-bootstrap/Alert'
const { exportOrderAmount } = require('../jsonToXlsx');
const { searchDownlineHR, getorderamount } = require('../Api');

var timer

class SeeOrderAmount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: Moment().toDate(),
      orderlist: [],
      SearchUSersModal: false,
      SearchedID : [],
      SearchUser: '',
      SelectedUser: '',
      showNotification: false,
      notificationType: '',
      notificationMessage: '',
      mode: 'single',
      loading: false,
      userID: '',
      checkDownline: false,
    }
    this.handleCloseSearchModal = this.handleCloseSearchModal.bind(this);
    this.SelectedUser = this.SelectedUser.bind(this);
  }

  async setSelectedDate(date, mode) {
    this.setState({
      [mode]: date
    });
  }

  openNotification(message, status) {
    this.setState({ notificationMessage: message, showNotification: true, notificationType: status });
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.setState({ showNotification: false, notificationMessage: '' });
    }, 5000);
  };
  async getorderamountF(mode) {
    if (this.state.userID !== '') {
      this.setState({ loading: true })
      const orderAmountList = await getorderamount(this.props.username, this.props.token, Moment(this.state.date).format('YYYY-MM-DD'), this.state.userID, mode ? 'combine' : '', this.state.checkDownline)
      this.setState({ orderlist: orderAmountList.readResult, loading: false })
    }

  }

  ShotCutKeySearchFunction(event) {
    if (event.key === 'Enter') {
      this.SearchFunction();
    }
  }

  async SearchFunction(){
    this.setState({ SearchUSersModal: true })
    if (this.state.SearchUser !== '') {
      const Searchresult = await searchDownlineHR(this.state.SearchUser, this.props.Role, this.props.userID, this.props.token, this.props.username)
      if(Searchresult.message === 'Invalid Downline ID or Username') {
        this.setState({ notificationType: 'error' }, () => {
          this.openNotification('InvalidDownlineIDorUsername')
        });
      } else {
        Searchresult.sort((a, b) => (a.Role > b.Role) ? 1 : -1)
        this.setState({ SearchedID: Searchresult })
      }
    }
  }

  handleCloseSearchModal() {
    this.setState({
      SearchUSersModal: false,
      SearchedID : [],
    })
  }

  SelectedUser(e) {
    this.setState({ userID: e.value, SelectedUser: e, SearchUser: e.label}, () => {
      this.handleCloseSearchModal();
    })
  }

  render() {
    return (
      <div className='StartBackground'>
        <Header />
        <Alert style={{ zIndex: 99, position: 'fixed', right: 0, top: 100, width: '70%', left: 250 }} 
          show={this.state.showNotification}
          variant={this.state.notificationType === 'error' ? 'danger' : 'success'}>
          <Alert.Heading>{this.state.notificationMessage}</Alert.Heading>
        </Alert>
        <SearchUsersModal SearchUSersModal={this.state.SearchUSersModal} SearchedID={this.state.SearchedID} SelectedUser={this.SelectedUser} handleCloseSearchModal={this.handleCloseSearchModal}/>
        <div style={{ paddingLeft: 10, display: 'flex', alignItems: 'center'}}>
          <div style={{ width: 300, display: 'flex', alignItems: 'center' }}>
            <div style={{ width: 100}}>{language[this.props.currentLanguage].Date}</div>
            <DatePicker
              onChange = {(date) => this.setState({ date })}
              dateFormat = 'dd-MMM-yyyy'
              placeholder="Date"
              selected={this.state.date}
              className={"form-control StyleDatePicker"}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center'}}>
            <div style={{ width: 100}}>{language[this.props.currentLanguage].Username}</div>
            <Form.Control style={{ width: 200}} type="text" placeholder="Username" value={this.state.SearchUser} onChange={(e) => this.setState({SearchUser: e.target.value})} onKeyPress={(e) => this.ShotCutKeySearchFunction(e)}/>
          </div>
          <Button style={{ marginLeft: 10, width: 100}} variant="primary" onClick={() => this.getorderamountF()}>
            {language[this.props.currentLanguage].Search}
          </Button>
          <Button style={{ marginLeft: 10, width: 200}} variant="primary" onClick={() => this.getorderamountF('combine')}>
            {language[this.props.currentLanguage].combineDay}{language[this.props.currentLanguage].Search}
          </Button>
          <Form.Check
            style={{ marginLeft: 10, width: 100, alignItems: 'center', display: 'flex' }}
            inline
            label={'找全下线'}
            type="checkbox"
            checked={this.state.checkDownline}
            onChange={(e) => this.setState({checkDownline: !this.state.checkDownline})}
          />
          <Button style={{ marginLeft: 100, width: 100}} variant="success" onClick={() => exportOrderAmount(this.props.currentLanguage, this.state.date, this.state.SearchUser, this.state.orderlist)}>Excel</Button>
        </div>
        <div style={{ width: 700, padding: 10, display: 'flex'}}>
          {this.state.searchResultUsername} {language[this.props.currentLanguage].danAmountResult} {language[this.props.currentLanguage].mode}
        </div>
        
        <div style={{ width: 700, padding: 10, display: 'flex'}}>
          <Table striped bordered hover style={{ backgroundColor: 'white'}}>
            <thead>
              <tr>
                <th>{`户口名`}</th>
                <th>{`S(ID)`}</th>
                <th>{`单数`}</th>
                <th>{`总`}</th>
              </tr>
            </thead>
            <tbody>
              {this.state.loading && <Spinner style={{ margin: 10}} animation="border" />}
              {this.state.orderlist.length === 0 
                ? 
                <>
                  <tr style={{ width: '100%', backgroundColor: '#C0C0C0', fontWeight: 'bold', fontSize: '20px'}}>
                    <td colSpan="3"> No Data</td>
                  </tr>
                </>
                :
                <>
                  {this.state.orderlist.map((item, idx) => {
                    return(
                      <tr key={idx}>
                        <td>{item.username || '-'}</td>
                        <td>{item.oID}</td>
                        <td>{item.uID}</td>
                        <td>{item.amt}</td>
                      </tr>
                    );
                  })}
                </>
              }
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.username,
    userID: state.userID,
    token: state.token,
    Role: state.Role,
    currentLanguage: state.currentLanguage,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setLoginStatus: (Username, UserToken, Role) => {
      dispatch({
        type: 'LOGIN_STATUS',
        payload: {
          username: Username,
          token: UserToken,
          Role: Role,
        },
      });
    },
    setLanguage: (lg) => {
      dispatch({ type: 'SET_LANGUAGE', payload: lg });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SeeOrderAmount);
